export enum EXTERNAL_ADDITIONAL_FIELDS_SOURCE {
    THIRD_PARTY = 'ThirdPartyMs',
}
